module.exports = __webpack_public_path__ + "img/BRAVO_1.02f75ef2.jpg";